
import { Options, Vue } from "vue-class-component";
@Options({
  components: {},
  computed: {
  }
})
export default class DetailCSV extends Vue {
}
